export default "__VITE_ASSET__230275c5__"